<template>
  <div>
    <div class="columns is-vcentered mgt-10px">
      <div class="column is-narrow">
        <p class="label">{{ $t('ajoutPresseDcf.popupSelection.du') }}</p>
      </div>
      <div class="column is-narrow">
        <b-datepicker show-week-number
                      @input="recherche"
                      nearby-selectable-month-days
                      v-model="dateDebut"
                      icon="calendar-today"
                      :editable="true">
        </b-datepicker>
      </div>
      <div class="column is-narrow">
        <p class="label">{{ $t('ajoutPresseDcf.popupSelection.au') }}</p>
      </div>
      <div class="column is-narrow">
        <b-datepicker show-week-number
                      @input="recherche"
                      nearby-selectable-month-days
                      v-model="dateFin"
                      icon="calendar-today"
                      :editable="true">
        </b-datepicker>
      </div>
    </div>
    <v-server-table v-if="startArrayRendering"
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    ref="tableListeParution" url="">
      <div slot="code" slot-scope="props">
        {{ props.row.code }}
      </div>
      <div slot="selected" slot-scope="props">
        <b-checkbox :value="props.row.selected" @input="addRemoveParution(props.row, $event)">
        </b-checkbox>
      </div>
      <div slot="nomParution" slot-scope="props">
        <router-link-blank :to="{ name: 'c.presse.parution', params: { id: props.row.id }}"
                           :message="props.row.nomParution">
        </router-link-blank>
      </div>
      <div slot="dateEnvoiCF" slot-scope="props">
        {{ props.row.dateEnvoiCF | formatDate }}
      </div>
      <div slot="dateEnvoiBAT" slot-scope="props">
        {{ props.row.dateEnvoiBAT | formatDate }}
      </div>
      <div slot="dateRemiseEltTech" slot-scope="props">
        {{ props.row.dateRemiseEltTech | formatDate }}
      </div>
      <div slot="dateParution" slot-scope="props">
        {{ props.row.dateParution | formatDate }}
      </div>
      <div slot="disponibilite" slot-scope="props">
        <b-tooltip                   position="is-left"
                                     :label="$t('listeParution.tab.infoDispo', {
          stock: props.row.ratioRestant, total: props.row.ratioCommercialisable,
          })">
          <b-icon icon="circle"
                :type="getColorDisponibilite(props.row)"/>
        </b-tooltip>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_POP_UP,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';
import {
  DELETE_PARUTION_BY_ID, INIT_PARUTION_SELECTED,
  SET_PARUTIONS_SELECTED,
} from '@/store/modules/presse/parution-mutation-type';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parution = createNamespacedHelpers('parution');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'selectionParution',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    onlyOneSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    emplacementId: {
      type: String,
      required: false,
    },
    surfaceId: {
      type: String,
      required: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      startArrayRendering: false,
      dateDebut: new Date(),
      dateFin: moment(this.dateDebut).add(1, 'y').toDate(),
    };
  },
  methods: {
    ...Parution.mapActions({
      actionLoadParutionVendable: 'loadVendable',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    recherche() {
      this.$refs.tableListeParution.refresh();
    },
    ...Parution.mapMutations({
      setParutionsSelected: SET_PARUTIONS_SELECTED,
      deleteParutionById: DELETE_PARUTION_BY_ID,
      initParutionSelected: INIT_PARUTION_SELECTED,
    }),
    getColorDisponibilite(parution) {
      if (parution.ratioVendu === 0) return 'is-success';
      if (parution.ratioRestant <= 0) return 'is-danger';
      return 'is-warning';
    },
    addRemoveParution(parution, value) {
      if (this.onlyOneSelect) {
        this.parutions.forEach((el) => {
          el.selected = false;
        });
        this.initParutionSelected([]);
      }
      if (value) {
        this.setParutionsSelected(parution);
        parution.selected = value;
      } else {
        this.deleteParutionById(parution.id);
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    updateDisponibiliteOfProduitByParution(parutionsLoad) {
      parutionsLoad.forEach((parution) => {
        parution.lignesCommandes
          .filter((el) => el.devisCommandeId === this.$route.params.id)
          .forEach((ligne) => {
            parution.ratioVendu -= ligne.ligneEncart.ratio;
            parution.ratioRestant += ligne.ligneEncart.ratio;
          });
      });
      return {};
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Parution.mapGetters({
      parutions: 'items',
      total: 'total',
      allCriteresRecherche: 'criteresRecherche',
      parutionsSelected: 'parutionsSelected',
    }),
    columns() {
      return ['selected', 'nomParution', 'numParution', 'code', 'dateEnvoiCF', 'dateEnvoiBAT', 'dateRemiseEltTech', 'dateParution', 'disponibilite'];
    },
    surfaces() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.surface);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeParution.tab.code'),
          numParution: this.$i18n.t('listeParution.tab.numParution'),
          nomParution: this.$i18n.t('listeParution.tab.nomParution'),
          dateEnvoiCF: this.$i18n.t('listeParution.tab.dateEnvoiCF'),
          dateEnvoiBAT: this.$i18n.t('listeParution.tab.dateEnvoiBAT'),
          dateRemiseEltTech: this.$i18n.t('listeParution.tab.dateRemiseEltTech'),
          dateParution: this.$i18n.t('listeParution.tab.dateParution'),
          selected: '',
          disponibilite: '',
        },
        filterable: ['nomParution', 'code'],
        filterByColumn: true,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: TEXTS,
        requestFunction: ((data) => {
          const dataClone = cloneDeep(data);
          data.query = cloneDeep(this.allCriteresRecherche);
          data.query.produitsId = [this.produit.id];
          data.query.societeId = this.societeActiveId;
          data.query.periodeDateParution.dateDebut = formatDate(this.dateDebut);
          data.query.periodeDateParution.dateFin = formatDate(this.dateFin);
          data.query.nomParution = dataClone.query.nomParution;
          data.query.code = dataClone.query.code;
          if (this.produit.controleDisponibilite) {
            if (this.emplacementId) {
              data.query.emplacementsId = [this.emplacementId];
            }
            if (this.surfaceId) {
              const surfaceFind = this.surfaces.find((el) => el.id === this.surfaceId);
              const higherOrEqualSurface = this.surfaces.filter((surface) => {
                return surface.ratio >= surfaceFind.ratio;
              });
              data.query.surfacesId = higherOrEqualSurface.map(el => el.id);
            }
          }
          return this.actionLoadParutionVendable(data);
        }),
        responseAdapter: (() => {
          this.updateDisponibiliteOfProduitByParution(this.parutions);
          return {
            data: this.parutions,
            count: this.total,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['code', 'numParution', 'nomParution', 'dateEnvoiCF', 'dateEnvoiBAT', 'dateRemiseEltTech', 'dateParution'],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.surface,
      ]);
      this.startArrayRendering = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
